import React from "react";
import GoogleButton from "./GoogleButton";
import styled from "styled-components";

const SocialsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2.5em;
`;

type Props = {
  isLogin: boolean;
  setShowProfilingModal: (showProfilingModal: boolean) => void;
};

const Socials = (props: Props) => {
  return (
    <SocialsWrapper>
      <GoogleButton {...props} />
    </SocialsWrapper>
  );
};

export default Socials;
